new (require('app/public-app/apps/entities')).API();
var Router = require('app/public-app/apps/router');

//Router
new Router();
